import React, { useState } from "react";
import "./CabPromoCodes.css";
import {
  RiCheckboxBlankCircleFill,
  RiCheckboxBlankCircleLine,
} from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

const CabPromoCodes = () => {
  const [promoCode, setPromoCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [message, setMessage] = useState("");

  const availableCoupons = [
    { code: "CAB250", description: "Get ₹250 OFF on your cab booking." },
    { code: "CABCASHBACK", description: "₹500 cashback on select cab rides." },
    { code: "UPICAB", description: "₹150 instant discount on UPI payments." },
    { code: "SAFEJOURNEY", description: "₹200 off with Trip Secure add-on." },
    { code: "CABSUPER", description: "₹300 instant discount on your ride." },
  ];

  const handleApply = () => {
    const trimmedCode = promoCode.trim();
    if (trimmedCode === "") {
      setMessage("Please enter a promo code.");
      return;
    }
    setAppliedCode(trimmedCode.toUpperCase());
    setMessage("Promo code applied successfully!");
  };

  const handleRemove = () => {
    setPromoCode("");
    setAppliedCode("");
    setMessage("");
  };

  const handleSelectCoupon = (code) => {
    const trimmedCode = code.trim();
    setPromoCode(trimmedCode);
    setAppliedCode(trimmedCode);
    setMessage("Promo code applied successfully!");
  };

  return (
    <div>
      {/* Desktop View */}
      <div className="cabPromocode_desktop">
        <section className="cabPromocode_wrap">
          <div
            className="cabPromocode_header"
            style={{
              backgroundImage:
                "linear-gradient(20deg, rgb(111 166 194) 20%, rgb(2 69 117) 100%)",
            }}
          >
            <span className="cabPromocode_title">
              <b>PROMO</b> CODES
            </span>
            <span className="cabPromocode_iconWrapper">
              <span
                className="cabPromocode_iconImg"
                style={{
                  backgroundImage:
                    'url("https://imgak.goibibo.com/flights-gi-assets/dt/rta_assets/promo-code.png")',
                }}
              />
            </span>
          </div>

          <div className="cabPromocode_inputSection">
            <input
              type="text"
              className="cabPromocode_input"
              placeholder="Enter promo code here"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              disabled={!!appliedCode}
            />
            <div className="cabPromocode_msgSection">
            {message && (
              <p className="cabPromocode_msgSuccess">{message}</p>
            )}
            {appliedCode && (
              <button
                className="cabPromocode_btnRemove"
                onClick={handleRemove}
                title="Remove Promo Code"
              >
                <RxCross2 size={20} color="#1a4f87" />
              </button>
            )}
            </div>
          </div>

          <div className="cabPromocode_couponList">
            {availableCoupons.map((coupon) => (
              <div
                key={coupon.code}
                className="cabPromocode_couponItem"
                onClick={() => handleSelectCoupon(coupon.code)}
              >
                <div className="cabPromocode_couponContent">
                  <span className="cabPromocode_couponIcon">
                    {appliedCode === coupon.code ? (
                      <RiCheckboxBlankCircleFill color="#2196f3" />
                    ) : (
                      <RiCheckboxBlankCircleLine color="#2196f3" />
                    )}
                  </span>
                  <div className="cabPromocode_couponText">
                    <span className="cabPromocode_couponCode">
                      {coupon.code}
                    </span>
                    <span className="cabPromocode_couponDescription">
                      {coupon.description}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Mobile View */}
      <div className="cabPromocode_mobile">
        <div className="cabPromocode_mobileWrapper">
          <div className="cabPromocode_mobileHeader">
            <img src="/Images/promo-code.png" alt="Coupon Icon" width="25" />
            <div className="cabPromocode_mobileTitle">
              Offers and Promo Codes
            </div>
            <img
              src="https://flight.easemytrip.com/M_Content/img/Icon-ionic-ios-arrow-back.svg"
              alt="back"
              style={{ marginLeft: "auto" }}
            />
          </div>

          <div className="cabPromocode_mobileInput">
            <input
              type="text"
              placeholder="Enter Coupon Code"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              disabled={!!appliedCode}
            />
            {appliedCode ? (
              <span className="removeText" onClick={handleRemove}>
                Remove
              </span>
            ) : (
              <span className="applyText" onClick={handleApply}>
                Apply
              </span>
            )}
          </div>

          {message && (
            <p className="cabPromocode_msgSuccess">{message}</p>
          )}

          <div className="cabPromocode_mobileCouponList">
            {availableCoupons.slice(0, 3).map((coupon) => (
              <label key={coupon.code} className="cabPromocode_couponRadio">
                <div>{coupon.code}</div>
                <span>{coupon.description}</span>
                <input
                  type="radio"
                  name="coupon"
                  checked={appliedCode === coupon.code}
                  onChange={() => handleSelectCoupon(coupon.code)}
                />
                {appliedCode === coupon.code ? (
                  <RiCheckboxBlankCircleFill color="#2196f3" />
                ) : (
                  <RiCheckboxBlankCircleLine color="#2196f3" />
                )}
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CabPromoCodes;
